import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    mergeFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";

const initialState = {
    activeStudent: null,
    activeStudentSinapsis: null,
};

export const Sinapsis = createSlice({
    name: "Sinapsis",
    initialState,
    reducers: {
        setActiveStudent: (state, action) => {
            state.activeStudent = action.payload;
        },
        clearActiveStudent: (state) => {
            state.activeStudent = initialState.activeStudent;
        },
        setActiveStudentSinapsis: (state, action) => {
            state.activeStudentSinapsis = action.payload;
        },
        clearActiveStudentSinapsis: (state) => {
            state.activeStudentSinapsis = initialState.activeStudentSinapsis;
        },
        clearState: (state) => {
            state = initialState;
        },
    },
});

export const {
    setActiveStudent,
    clearActiveStudent,
    setActiveStudentSinapsis,
    clearActiveStudentSinapsis,
    clearState,
} = Sinapsis.actions;

export default Sinapsis.reducer;

export const startGetByStudentNumber = (student_number) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("student_number", student_number);

        const resp = await Call(
            `services/sinapsis/api/get-by-student-number`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setActiveStudentSinapsis(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGetByStudentNumberOld = (
    student_number,
    student_number_old
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("student_number", student_number);
        params.set("student_number_old", student_number_old);

        const resp = await Call(
            `services/sinapsis/api/get-by-student-number-old`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setActiveStudentSinapsis(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSinapsisImportStudent = (
    student_number,
    student_number_old,
    callback = () => {},
    swalToast = false
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `services/sinapsis/api/import-student`,
            "POST",
            { student_number, student_number_old }
        );

        if (resp.success) {
            if (resp.success?.studentsNotFoundInSinapsis?.length > 0) {
                const studentNumbers =
                    resp.success.studentsNotFoundInSinapsis.map(
                        (studentNumber) => `● ${studentNumber}`
                    );

                const msg =
                    studentNumbers.length === 1
                        ? "La siguiente matrícula no se encontró en Sinapsis:"
                        : "Las siguientes matrículas no se encontraron en Sinapsis:";

                Swal.fire({
                    icon: "warning",
                    title: "Alerta",
                    html: `
                        <span style="text-align: center">
                            <span>${msg}</span>
                        </span>

                        <br/>
                        <br/>

                        <span style="text-align: center">${studentNumbers.join(
                            "<br/>"
                        )}
                        </span>
                    `,
                    width: 500,
                });
            } else if (
                resp.success?.studentsWithoutSinapsisSchoolSubjects?.length > 0
            ) {
                const studentNumbers =
                    resp.success.studentsWithoutSinapsisSchoolSubjects.map(
                        (studentNumber) => `● ${studentNumber}`
                    );

                const msg =
                    studentNumbers.length === 1
                        ? "La siguiente matrícula no cuenta con materias en Sinapsis:"
                        : "Las siguientes matrículas no cuentan con materias en Sinapsis:";

                Swal.fire({
                    icon: "warning",
                    title: "Alerta",
                    html: `
                        <span style="text-align: center">
                            <span>${msg}</span>
                        </span>

                        <br/>
                        <br/>

                        <span style="text-align: center">${studentNumbers.join(
                            "<br/>"
                        )}
                        </span>
                    `,
                    width: 500,
                });
            } else if (resp.success?.sinapsisCurriculumNotFound?.length > 0) {
                const curriculums = resp.success.sinapsisCurriculumNotFound.map(
                    (curriculum) => `● ${curriculum}`
                );

                const msg =
                    curriculums.length === 1
                        ? "La siguiente carrera de Sinapsis no se encuentra añadida en el array curriculumList:"
                        : "Las siguientes carreras de Sinapsis no se encuentran añadidas en el array curriculumList:";

                Swal.fire({
                    icon: "warning",
                    title: "Alerta",
                    html: `
                        <span style="text-align: center">
                            <span>${msg}</span>
                        </span>

                        <br/>
                        <br/>

                        <span style="text-align: center">${curriculums.join(
                            "<br/>"
                        )}
                        </span>
                    `,
                    width: 500,
                });
            } else if (resp.success?.failedStudents?.length > 0) {
                const studentNumbers = resp.success.failedStudents.map(
                    (studentNumber) => `● ${studentNumber?.student_number}`
                );

                const msg =
                    studentNumbers.length === 1
                        ? "Ocurrió un error al tratar de importar para la siguiente matrícula:"
                        : "Ocurrió un error al tratar de importar para las siguientes matrículas:";

                Swal.fire({
                    icon: "warning",
                    title: "Alerta",
                    html: `
                        <span style="text-align: center">
                            <span>${msg}</span>
                        </span>

                        <br/>
                        <br/>

                        <span style="text-align: center">${studentNumbers.join(
                            "<br/>"
                        )}
                        </span>
                    `,
                    width: 500,
                });
            } else {
                Swal.fire({
                    title: "Éxito",
                    text: "Datos importados",
                    icon: "success",
                    toast: swalToast,
                    position: swalToast ? "bottom-end" : "center",
                    timer: swalToast ? 6000 : undefined,
                });
            }

            callback();
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSinapsisExportStudent = (student_number) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `services/sinapsis/api/export-student`,
            "POST",
            { student_number }
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Estudiante exportado",
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startSinapsisUpdateDebt = (
    student_number,
    has_debt,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`services/sinapsis/api/update-debt`, "POST", {
            student_number,
            has_debt,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Adeudo actualizado",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 2000,
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
